import { useEffect } from 'react';

import { NotificationManager, StorageManager } from '@atlas/core';

import { ALWAYS_ALLOWED_PAGES, LEAVE_SIGNUP_NOTIFICATION_ID } from 'common/constants';

import { isRegistrationFlowActive } from './useRegistrationFlowActive';

const useLeaveSignupBlocker = ({
  enabled,
  history,
  isMultiStepFlow = false,
  isPartiallyRegistered = false,
  onLeave,
  onPopupShown,
  popupType,
  shouldBypassBlock,
}) => {
  useEffect(() => {
    if (!enabled) return;

    let leaveFired = false;

    const unblock = history.block(location => {
      if (shouldBypassBlock?.()) return;

      const isLeavePopupShown = StorageManager.getItem('leavePopupShown') === 'shown';
      const shouldShowLeavePopup = isMultiStepFlow
        ? isRegistrationFlowActive() && (!isLeavePopupShown || isPartiallyRegistered)
        : !isLeavePopupShown && !isPartiallyRegistered;

      const shouldBlockNavigation =
        !ALWAYS_ALLOWED_PAGES.includes(location.pathname) &&
        !location.search?.includes('cmd=signup') &&
        shouldShowLeavePopup;

      if (shouldBlockNavigation) {
        NotificationManager.display({
          data: {
            history,
            location,
            type: popupType,
            unblock,
          },
          id: LEAVE_SIGNUP_NOTIFICATION_ID,
          message: 'leaveSignup',
          type: 'leaveSignup',
        });
        onPopupShown?.();
        return false;
      }

      if (!leaveFired && !ALWAYS_ALLOWED_PAGES.includes(location.pathname)) {
        leaveFired = true;
        onLeave?.();
      }
    });

    return () => unblock();
  }, [
    enabled,
    history,
    isMultiStepFlow,
    isPartiallyRegistered,
    onLeave,
    onPopupShown,
    popupType,
    shouldBypassBlock,
  ]);
};

export default useLeaveSignupBlocker;
